import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Tres = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Key Metrics</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}><ul><li>Customer satisfaction is important, <b>Here the customers and clients will give feedback about any side effects they may have had, any manufacturing and functionality flaws, and whichever suggestion, complaint, or observation they have noticed with iMoAge.</b></li><li>This will provide another way to keep track of the impact that the product has and not only qualitatively but also quantitatively and it will be for the benefit of all. Also it will be a key parameter <b>for us to monitor and improve our test.</b></li></ul></Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '70%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-26-jpg.jpg'/>
          <p><b>Fig. 6.3</b>Complementary image of the <q>Key Metrics</q> section in the Business Model Canva . Knowing our customer´s experience will be an important factor that will determine if our kit cover the needs.</p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Tres;
